// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-header[data-v-fd10675a] {\n  font-family: \"Proxima Nova\";\n  font-weight: 600;\n  font-size: 17px;\n  padding-left: 20px;\n}\n.custom-body[data-v-fd10675a] {\n  padding: 1em 0;\n  border: 2px solid #f0f0f0;\n  border-width: 2px 0;\n  height: 350px;\n  max-height: calc(100vh - 130px);\n}\n.no-btn[data-v-fd10675a] {\n  color: #6e478f;\n}\n", ""]);
// Exports
module.exports = exports;
